export default
    {
    //'apiurl':'http://localhost:3001', //  URL API LOCALHOST
    //'urlweb': 'http://localhost:8081', //  URL FRONTEND

    //'urlweb': 'https://dev.assuraf.com/', //  URL FRONTEND
    //'apiurl': 'https://assurapi.assuraf.com/apicloudmigration',

    'urlweb': 'https://assuraf.com/', //  URL FRONTEND
    'apiurl': 'https://assurapi.assuraf.com/apicloud/', //  URL API

    //'urlweb': 'https://demo.assuraf.com/', //  URL FRONTEND
    //'apiurl': 'https://assurapi.assuraf.com/apitest',
    'apiorangemoney': 'https://apiom.assuraf.com/', //  PHP API URL
    'orabank' : '',
    'user': {
        'avatar': '../../assets/img/user_icon.png'
    }
}
